class NCOLReviews extends HTMLElement {
    constructor() {
        super();

        this.initial = true;
        this.summary = {};
        this.tags = [];
        this.reviews = [];
        this.reviewCount = 0;
        this.uploadedImageIDs = [];
        this.paginationAmount = 5;
        this.currentPage = 1;
        this.searchTerm = "";
        this.filterRatings = [];
        this.filterImages = false;
        this.filterVerified = false;
        this.sortType = "recent";
        this.customerEmail = this.getAttribute("data-customer-email");
        this.productID = this.getAttribute("data-product-id");

        // Strip any trailing slash from baseURL
        this.baseURL = this.getAttribute("data-base-url");
        if (this.baseURL.endsWith("/")) this.baseURL = this.baseURL.slice(0, -1);

        // Setup review template
        this.reviewList = {
            list: this.querySelector('[data-review-list="list"]'),
            reviewTemplate: this.querySelector('[data-review-list="template-review"]'),
            paginationButtonTemplate: this.querySelector("#js-ncol-reviews-pagination-template")
        };

        this.formFields = {
            title: document.querySelector('#ncol-reviews-write-form [name="title"]'),
            body: document.querySelector('#ncol-reviews-write-form [name="body"]'),
            author: document.querySelector('#ncol-reviews-write-form [name="author"]'),
            email: document.querySelector('#ncol-reviews-write-form [name="email"]')
        };

        this.setupControls();
        this.getSummary();
        this.getReviews(true);

        document.querySelector("#ProductPopup-ncol-reviews-write").addEventListener("click", async (e) => {
            this.getTagsForForm();
        });

        // submit review form
        document.querySelector("#ncol-reviews-write-form").addEventListener("submit", async (e) => {
            e.preventDefault();

            // get all values from formFields and create a formData object
            const formData = new FormData();
            const ratingChecked = document.querySelector('#ncol-reviews-write-form [name="rating"]:checked');
            if (ratingChecked) {
                formData.append("rating", ratingChecked.value);
            }
            const recommendedNode = document.querySelector('#ncol-reviews-write-form [name="ncol-review-recommend"]:checked');
            const recommended = recommendedNode ? recommendedNode.value === "yes" : false;
            formData.append("product_id", this.productID);
            formData.append("recommended", recommended);
            if (this.formFields.title.value.length > 0) {
                formData.append("title", this.formFields.title.value);
            }
            formData.append("body", this.formFields.body.value);
            formData.append("author", this.formFields.author.value);
            formData.append("email", this.formFields.email.value);
            document.querySelectorAll(".js-ncol-reviews-form-tagchoices").forEach((tagChoice) => {
                const tagID = tagChoice.querySelector("input[type='radio']:checked");
                if (tagID) {
                    formData.append("tag_ids[]", tagID.value);
                }
            });
            document.querySelectorAll("#js-ncol-review-form-tagsmore input[type='checkbox']:checked").forEach((tag) => {
                formData.append("tag_ids[]", tag.value);
            });
            this.uploadedImageIDs.forEach((imageID) => {
                formData.append("images[]", imageID);
            });

            e.target.classList.add("is-loading");

            // submit the form data to the API
            await fetch(`${this.baseURL}/api/reviews`, {
                method: "POST",
                body: formData
            })
                .then((response) => response.json())
                .then((data) => {
                    const errorsNode = document.querySelector("#js-ncol-reviews-write-validation-errors");
                    if (data.errors) {
                        // Show validation errors
                        const listNode = errorsNode.querySelector("#js-ncol-reviews-write-validation-errors-list");
                        listNode.innerHTML = ``;
                        data.errors.forEach((error) => {
                            listNode.innerHTML += `<li>${error}</li>`;
                        });
                        errorsNode.classList.remove("hidden");
                        document.querySelector('#PopupModal-ncol-reviews-write [role="dialog"]').scrollTo({ top: 0, behavior: "smooth" });
                    } else {
                        // Handle the response data
                        errorsNode.textContent = "";
                        errorsNode.classList.add("hidden");
                        document.querySelector("#js-ncol-reviews-write-form-wrap").classList.add("hidden");
                        const completeNode = document.querySelector("#js-ncol-reviews-write-form-complete");
                        completeNode.classList.remove("hidden");
                        completeNode.classList.add("is-entering");
                    }
                })
                .catch((error) => {
                    // Handle any errors
                    console.error("Error submitting review", error);
                });

            e.target.classList.remove("is-loading");
        });

        // open file upload dialog when image upload button is clicked
        document.querySelector("#js-ncol-reviews-write-image-upload").addEventListener("click", (e) => {
            document.querySelector("#js-ncol-reviews-write-image-file").click();
        });

        // handle image upload
        document.querySelector("#js-ncol-reviews-write-image-file").addEventListener("change", (e) => {
            // clear existing error message if exists
            document.querySelector("#js-ncol-reviews-write-imageupload-error")?.remove();

            // setup img file for posting
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append("image", file);

            // check if file is larger than 5MB
            if (file.size > 5 * 1024 * 1024) {
                const errorMessage = document.createElement("div");
                errorMessage.classList.add("ncol-reviews-write__error-message");
                errorMessage.id = "js-ncol-reviews-write-imageupload-error";
                errorMessage.textContent = "Image must be less than 5MB.";
                document.querySelector("#js-ncol-reviews-write-image").appendChild(errorMessage);
                return;
            }

            // add image preview
            const img = document.createElement("img");
            img.src = URL.createObjectURL(file);
            const imagePreviewDelete = document.createElement("button");
            imagePreviewDelete.classList.add("ncol-reviews-write__images-uploaded-item-delete");
            const imagePreviewSquare = document.createElement("div");
            imagePreviewSquare.appendChild(img);
            imagePreviewSquare.classList.add("ncol-reviews-write__images-uploaded-item");
            imagePreviewSquare.classList.add("is-uploading");
            document.querySelector("#js-ncol-reviews-write-image-uploaded").appendChild(imagePreviewSquare);

            // send to server
            fetch(`${this.baseURL}/api/images`, {
                method: "POST",
                body: formData
            })
                .then((response) => response.json())
                .then((data) => {
                    // Handle the response data
                    if (data.error) {
                        imageUploadError(data.error);
                    } else {
                        this.uploadedImageIDs.push(data);
                        imagePreviewSquare.classList.remove("is-uploading");
                        imagePreviewSquare.appendChild(imagePreviewDelete);
                        imagePreviewDelete.addEventListener("click", (e) => {
                            imagePreviewSquare.remove();
                            const index = this.uploadedImageIDs.indexOf(data);
                            if (index > -1) {
                                this.uploadedImageIDs.splice(index, 1);
                            }
                            imageUploadShowHideField();
                        });
                        imageUploadShowHideField();
                    }
                })
                .catch((data) => {
                    if (data.error) {
                        imageUploadError(data.error);
                    }
                });

            const imageUploadError = (message) => {
                imagePreviewSquare.remove();
                const errorMessage = document.createElement("div");
                errorMessage.classList.add("ncol-reviews-write__error-message");
                errorMessage.id = "js-ncol-reviews-write-imageupload-error";
                errorMessage.textContent = message;
                document.querySelector("#js-ncol-reviews-write-image").appendChild(errorMessage);
                imageUploadShowHideField();
            };

            const imageUploadShowHideField = () => {
                const imageUploadField = document.querySelector("#js-ncol-reviews-write-image-field");
                if (this.uploadedImageIDs.length >= 3) {
                    imageUploadField.classList.add("hidden");
                } else {
                    imageUploadField.classList.remove("hidden");
                }
            };
        });

        // close modal when after submit complete button is clicked
        document.querySelector("#ModalClose-ncol-reviews-write-form-complete").addEventListener("click", (e) => {
            document.querySelector("#PopupModal-ncol-reviews-write").hide();
        });

        this.initial = false;
    }

    connectedCallback() {
        this.colorChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productColorChange, (event) => {
            document.getElementById("PopupModal-ncol-reviews-write").remove();
        });
    }

    disconnectedCallback() {
        if (this.colorChangeUnsubscriber) {
            this.colorChangeUnsubscriber();
        }
    }

    showError(e) {
        // TODO: hide review componenet if there is an error getting reviews
        console.error(e);
    }

    showHideRemoveFiltersContainer() {
        const removeFilterButtons = this.querySelectorAll("#js-ncol-reviews-remove-filters button");
        const showRemoveFilterButtons = Array.from(removeFilterButtons).some((button) => !button.classList.contains("hidden"));
        this.querySelector("#js-ncol-reviews-remove-filters").classList.toggle("hidden", !showRemoveFilterButtons);
    }

    setupControls() {
        // search
        this.querySelector("#input_ncol-reviews_controls_search").addEventListener("input", (e) => {
            // Debounce the search handler
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.searchTerm = e.target.value;
                this.querySelector(`#js-ncol-reviews-remove-filter-search`).classList.toggle("hidden", this.searchTerm.length === 0);
                this.querySelector(`#js-ncol-reviews-remove-filter-search-term`).innerHTML = this.searchTerm;
                this.showHideRemoveFiltersContainer();
                reloadReviews();
            }, 300);
        });

        // filters
        const filterRatingCheckboxes = document.querySelectorAll(".js-ncol-reviews-filter-rating-checkbox");
        filterRatingCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", (e) => {
                const checked = e.target.checked;
                const rating = e.target.getAttribute("data-rating");
                if (checked && !this.filterRatings.includes(rating)) {
                    this.filterRatings.push(rating);
                } else {
                    const index = this.filterRatings.indexOf(rating);
                    if (index > -1) {
                        this.filterRatings.splice(index, 1);
                    }
                }
                this.querySelector(`#js-ncol-reviews-remove-filter-${rating}stars`).classList.toggle("hidden", !checked);
                this.showHideRemoveFiltersContainer();
                reloadReviews();
            });
        });
        document.querySelector("#input_ncol-reviews_controls_hasimage").addEventListener("change", (e) => {
            const checked = e.target.checked;
            this.filterImages = checked;
            this.querySelector(`#js-ncol-reviews-remove-filter-image`).classList.toggle("hidden", !checked);
            this.showHideRemoveFiltersContainer();
            reloadReviews();
        });
        document.querySelector("#input_ncol-reviews_controls_isverified").addEventListener("change", (e) => {
            const checked = e.target.checked;
            this.filterVerified = checked;
            this.querySelector(`#js-ncol-reviews-remove-filter-verified`).classList.toggle("hidden", !checked);
            this.showHideRemoveFiltersContainer();
            reloadReviews();
        });

        // close menus if click outside
        document.addEventListener("click", (e) => {
            const reviewsSort = this.querySelector("#reviews-sort");
            const reviewsFilters = this.querySelector("#reviews-filters");
            if (!reviewsSort && !reviewsFilters) return;
            if (!reviewsSort.contains(e.target) && !reviewsFilters.contains(e.target)) {
                reviewsSort.removeAttribute("open");
                reviewsFilters.removeAttribute("open");
            }
        });

        // remove filters
        document.querySelectorAll(".js-ncol-reviews-remove-filter-stars").forEach((button) => {
            button.addEventListener("click", (e) => {
                const rating = e.target.getAttribute("data-rating");
                const index = this.filterRatings.indexOf(rating);
                if (index > -1) {
                    this.filterRatings.splice(index, 1);
                }
                clearFilter(`#input_ncol-reviews_controls_${rating}stars`, e.target);
                e.target.classList.add("hidden");
            });
        });
        this.querySelector("#js-ncol-reviews-remove-filter-search").addEventListener("click", (e) => {
            this.searchTerm = "";
            this.querySelector("#input_ncol-reviews_controls_search").value = "";
            this.querySelector("#js-ncol-reviews-remove-filter-search").classList.add("hidden");
            this.showHideRemoveFiltersContainer();
            reloadReviews();
        });
        this.querySelector("#js-ncol-reviews-remove-filter-image").addEventListener("click", (e) => {
            this.filterImages = false;
            clearFilter("#input_ncol-reviews_controls_hasimage", e.target);
        });
        this.querySelector("#js-ncol-reviews-remove-filter-verified").addEventListener("click", (e) => {
            this.filterVerified = false;
            clearFilter("#input_ncol-reviews_controls_isverified", e.target);
        });
        const clearFilter = (checkboxSelector, button) => {
            this.querySelector(checkboxSelector).checked = false;
            button.classList.add("hidden");
            this.showHideRemoveFiltersContainer();
            reloadReviews();
        };

        // close menus when other is opened
        this.querySelector("#reviews-sort").addEventListener("click", (e) => {
            this.querySelector("#reviews-filters").removeAttribute("open");
        });
        this.querySelector("#reviews-filters").addEventListener("click", (e) => {
            this.querySelector("#reviews-sort").removeAttribute("open");
        });

        // Focus trapping
        this.querySelectorAll('[data-dropdown]').forEach(dropdown => {
            dropdown.addEventListener('click', (e) => {
                const detailsPanel = e.target.closest('details');
                const content = detailsPanel.querySelector('[data-dropdown-content]');
                if (detailsPanel.hasAttribute('open')) {
                    removeTrapFocus();
                    return;
                }

                trapFocus(content, { escapeHandler: () => {
                    detailsPanel.removeAttribute('open');
                    return dropdown;
                }});
            });
        });

        // sort type
        const sortTypeRadios = document.querySelectorAll("[data-controls='sort-type']");
        sortTypeRadios.forEach((radio) => {
            radio.addEventListener("change", (e) => {
                this.sortType = e.target.value;
                let sortTypeDescriptive = "Most Recent";
                if (this.sortType === "rating") {
                    sortTypeDescriptive = "Highest Rating";
                }
                if (this.sortType === "helpful") {
                    sortTypeDescriptive = "Most Helpful";
                }
                this.querySelector('[data-controls="status-sort"]').textContent = `Sorted by ${sortTypeDescriptive}`;
                reloadReviews();
            });
        });

        const reloadReviews = () => {
            this.currentPage = 1;
            this.getReviews();
        };
    }

    async getSummary() {
        try {
            // Get summary for product
            const fetchRes = await fetch(`${this.baseURL}/api/reviews/summary/?product_id=${this.productID}`, { cache: "no-cache" });
            this.summary = await fetchRes.json();
        } catch (e) {
            this.showError(e);
            return;
        }

        if (this.summary.count > 0) {
            // for each review, create a new review item
            this.querySelector('[data-summary="stars"]').setAttribute("style", `--rating: ${this.summary.average}; --rating-max: 5.0; --rating-decimal: 0;`);
            this.querySelector('[data-summary="total-score"]').textContent = `${this.summary.average} stars`;
            this.querySelector('[data-summary="total-score-screen-reader"]').textContent = `${this.summary.average} out of 5 stars`;
            this.querySelector('[data-summary="ratings"]').textContent = this.summary.count === 1 ? `${this.summary.count} rating` : `${this.summary.count} ratings`;

            const starDistributionEntries = Object.entries(this.summary.distribution);
            const starDistribution = starDistributionEntries.reverse();

            // for each key in starDistribution, calculate the percentage of total reviews
            const starPercents = starDistribution.map((star) => {
                return Math.floor((star[1] / this.summary.count) * 100);
            });

            // for each key in this.summary.distrubtion object, create a new summary item
            starDistribution.forEach(([starLevel, reviewCount], i) => {
                const starGraphLine = this.querySelector('[data-summary="summary-line"]').content.cloneNode(true);
                starGraphLine.querySelector('[data-summary="summary-line-graph"]').setAttribute("style", `--percent: ${starPercents[i]};`);
                starGraphLine.querySelector('[data-summary="summary-line-label"]').textContent = starLevel === "1" ? `${starLevel} star` : `${starLevel} stars`;
                starGraphLine.querySelector('[data-summary="summary-line-screen-reader"]').textContent = `${starPercents[i]}% rated ${starLevel === "1" ? `${starLevel} star` : `${starLevel} stars`}`;
                this.querySelector('[data-summary="summary-lines"').appendChild(starGraphLine);
            });

            // setup tag rating graphs
            if (this.summary.tags.length > 0) {
                let tagRatingCount = 0;
                this.summary.tags.forEach((tag) => {
                    if (tagRatingCount >= 4 || !tag.left || !tag.right || (tag.left.count == 0 && tag.right.count == 0)) {
                        return;
                    }
                    const tagRating = this.querySelector('[data-summary="tag-rating"]').content.cloneNode(true);
                    const calculateSegment = (left, right) => {
                        return Math.round((left + right * 5) / (left + right));
                    };
                    const segment = calculateSegment(tag.left.count, tag.right.count) || 0;

                    let segmentAsText = '';
                    switch (segment) {
                        case 1:
                            segmentAsText = `${tag.left.value}`;
                            break;
                        case 2:
                            segmentAsText = `Mostly ${tag.left.value}`;
                            break;
                        case 3:
                            segmentAsText = `Mixed (Not ${tag.left.value} or ${tag.right.value})`;
                            break;
                        case 4:
                            segmentAsText = `Mostly ${tag.right.value}`;
                            break;
                        case 5:
                            segmentAsText = `${tag.right.value}`;
                            break;
                    }

                    tagRating.querySelector('[data-summary="tag-rating-graph"]').setAttribute("style", `--segment: ${segment};`);
                    tagRating.querySelector('[data-summary="tag-rating-label-left"]').textContent = tag.left.value;
                    tagRating.querySelector('[data-summary="tag-rating-label-right"]').textContent = tag.right.value;
                    tagRating.querySelector('[data-summary="tag-rating-screen-reader"]').textContent = segmentAsText;
                    this.querySelector('[data-summary="tag-ratings"').appendChild(tagRating);
                    tagRatingCount += 1;
                });
                if (tagRatingCount == 0) {
                    this.querySelector('[data-summary="tag-ratings"]').remove();
                }
            } else {
                this.querySelector('[data-summary="tag-ratings"]').remove();
            }
        } else {
            const noReviewsNode = document.createElement("div");
            noReviewsNode.classList.add("ncol-reviews__no-reviews");
            noReviewsNode.textContent = "No reviews yet, be the first!";
            this.querySelector('[data-summary="summary"]').prepend(noReviewsNode);
            this.querySelector('[data-summary="summary"]').classList.add("ncol-reviews__summary--no-reviews");
            this.querySelector('[data-summary="summary-lines"]').remove();
            this.querySelector('[data-summary="summary-recap"]').remove();
            this.querySelector('[data-summary="tag-ratings"]').remove();
            this.querySelector('[data-controls="controls"]').remove();
            this.querySelector('[data-review-list="list"]').remove();
        }

        this.classList.remove("is-loading");
    }

    async getReviews(initial = false) {
        // add loading state
        this.querySelector('[data-review-list="section"]').classList.add("is-loading");

        // load reviews
        try {
            const top = this.paginationAmount;
            const skip = (this.currentPage - 1) * this.paginationAmount;

            const searchParams = new URLSearchParams();
            searchParams.append("product_id", this.productID);
            if (!initial) {
                searchParams.append("skip", skip);
                searchParams.append("top", top);
            }
            this.filterRatings.forEach(rating => searchParams.append("filter_ratings[]", rating));
            if (this.filterVerified) searchParams.append("filter_verified", "true");
            if (this.filterImages) searchParams.append("filter_images", "true");
            if (this.sortType === "recent") searchParams.append("sort_recent", "desc");
            if (this.sortType === "helpful") searchParams.append("sort_helpful", "desc");
            if (this.sortType === "rating") searchParams.append("sort_rating", "desc");
            if (this.searchTerm !== "") searchParams.append("search", this.searchTerm);

            const searchURL = `${this.baseURL}/api/reviews/?${searchParams.toString()}`;
            const fetchRes = await fetch(searchURL, { cache: "no-cache" });
            const data = await fetchRes.json();
            this.reviews = data.reviews;
            this.reviewCount = data.total;
        } catch (e) {
            this.showError(e);
        }

        // clear list
        this.reviewList.list.innerHTML = "";
        this.querySelector("#js-ncol-reviews-pagination").innerHTML = "";

        // remove loading state
        this.querySelector('[data-review-list="section"]').classList.remove("is-loading");

        // if reviews, render list
        if (this.reviews.length > 0) {
            this.renderReviewList();
            this.setReviewSchema();
        } else {
            // show empty state
            const anyActiveFiltersOrSearch = this.filterRatings.length > 0 || this.filterImages || this.filterVerified || this.searchTerm != "";
            const emptyMessage = anyActiveFiltersOrSearch ? "No reviews found, try other filters." : "No reviews yet, be the first!";
            const noReviewsNode = document.createElement("div");
            noReviewsNode.classList.add("ncol-reviews-list__no-reviews");
            noReviewsNode.textContent = emptyMessage;

            const reviewList = this.querySelector('[data-review-list="list"]');
            if (reviewList) {
                reviewList.appendChild(noReviewsNode);
                reviewList.classList.add("ncol-reviews__review-list--no-reviews");
            }

            const statusControls = this.querySelector('[data-controls="status"]');
            if (statusControls) {
                statusControls.classList.add("hidden");
            }
        }
    }

    formatReviewedOnDate(timestamp) {
        const createdDate = new Date(timestamp);
        const currentDate = new Date();
        const timeDiff = Math.abs(currentDate - createdDate);
        const daysAgo = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        let formattedDate;
        if (daysAgo === 0) {
            formattedDate = "reviewed today";
        } else if (daysAgo === 1) {
            formattedDate = `reviewed ${daysAgo} day ago`;
        } else if (daysAgo < 365) {
            formattedDate = `reviewed ${daysAgo} days ago`;
        } else {
            const yearsAgo = Math.floor(daysAgo / 365);
            formattedDate = `reviewed ${yearsAgo} years ago`;
        }
        return formattedDate;
    }

    renderReviewList() {
        this.reviews.forEach((review, index) => {
            if (index >= this.paginationAmount) return;

            const listItem = this.reviewList.reviewTemplate.content.cloneNode(true);
            listItem.querySelector('[data-review-list="li"]').setAttribute("data-id", review.ID);
            listItem.querySelector('[data-review-list="author"]').textContent = review.author;
            listItem.querySelector('[data-review-list="date"]').textContent = this.formatReviewedOnDate(review.created_date);
            if (!review.verified) {
                listItem.querySelector('[data-review-list="verified"]').remove();
            }
            if (!review.recommended) {
                listItem.querySelector('[data-review-list="recommended"]').remove();
            }
            if (review.tags.length > 0) {
                let tagsHTML = "";
                review.tags.forEach(function (tag) {
                    tagsHTML += `<div class="ncol-reviews-list__review-header-tag">${tag}</div>`;
                }, this);
                listItem.querySelector('[data-review-list="tags"]').innerHTML = tagsHTML;
            } else {
                listItem.querySelector('[data-review-list="tags"]').remove();
            }
            if (review.images.length > 0) {
                let imagesHTML = "";
                review.images.forEach(function (imageURL) {
                    imagesHTML += `<img src="${this.baseURL + imageURL}" alt="" />`;
                }, this);
                listItem.querySelector('[data-review-list="images"]').innerHTML = imagesHTML;
            } else {
                listItem.querySelector('[data-review-list="images"]').remove();
            }
            listItem.querySelector('[data-review-list="stars-description"]').setAttribute("aria-label", `${review.rating} out of 5 stars`);
            listItem.querySelector('[data-review-list="stars"]').setAttribute("style", `--rating: ${review.rating}; --rating-max: 5.0; --rating-decimal: 0;`);
            listItem.querySelector('[data-review-list="title"]').textContent = review.title;
            listItem.querySelector('[data-review-list="body"]').textContent = review.body;
            if (review.response) {
                listItem.querySelector('[data-review-list="response-body"]').textContent = review.response;
            } else {
                listItem.querySelector('[data-review-list="response"]').remove();
            }

            review.listItem = listItem.children[0];
        }, this);

        // append all review html nodes to the list element
        this.reviews.forEach(function (review) {
            if (!review.listItem) return;
            this.reviewList.list.appendChild(review.listItem);
        }, this);

        // setup helpful/not helpful button handlers
        this.querySelectorAll(".js-ncol-reviews-helpful").forEach((button) => {
            button.addEventListener("click", (e) => {
                const targetReview = e.target.closest('[data-review-list="li"]');
                const reviewID = targetReview.getAttribute("data-id");
                const targetNode = e.target.closest(".js-ncol-reviews-helpful");
                const formData = new FormData();
                const buttonType = targetNode.getAttribute("data-direction");
                if (buttonType == "up") {
                    formData.append("like", true);
                } else {
                    formData.append("dislike", true);
                }
                formData.append("email", this.customerEmail);
                fetch(`${this.baseURL}/api/reviews/${reviewID}`, {
                    method: "POST",
                    body: formData
                })
                    .then((response) => response.json())
                    .then((data) => {
                        // Handle the response data
                        const wrapNode = targetNode.closest(".js-ncol-reviews-helpful-wrap");
                        const otherButtonType = buttonType == "up" ? "down" : "up";
                        const otherNode = wrapNode.querySelector(`.js-ncol-reviews-helpful[data-direction="${otherButtonType}"]`);
                        otherNode.classList.remove("is-active");
                        targetNode.classList.add("is-active");
                    })
                    .catch((error) => {
                        // Handle any errors
                        console.error("Error submitting helpful/not helpful", error);
                    });
                e.preventDefault();
            });
        });

        // update pagination text
        const reviewsPluralization = this.reviewCount > 1 ? "reviews" : "review";
        const currentReviewStart = (this.currentPage - 1) * this.paginationAmount + 1;
        const currentReviewEnd = (this.currentPage - 1) * this.paginationAmount + this.reviews.length;
        this.querySelector('[data-controls="status-pagination"]').textContent = `${currentReviewStart}-${currentReviewEnd} of ${this.reviewCount} ${reviewsPluralization}`;
        this.querySelector('[data-controls="status"]').classList.remove("hidden");

        // render pagination
        const pagination = this.querySelector("#js-ncol-reviews-pagination");
        const totalPages = Math.ceil(this.reviewCount / this.paginationAmount);
        if (totalPages > 1) {
            for (let i = 0; i < totalPages; i++) {
                const pageButton = this.reviewList.paginationButtonTemplate.content.cloneNode(true);
                pageButton.querySelector("button").textContent = i + 1;
                pageButton.querySelector("button").setAttribute("data-page", i + 1);
                if (i + 1 == this.currentPage) {
                    pageButton.querySelector("button").classList.add("is-active");
                }
                pageButton.querySelector("button").addEventListener("click", (e) => {
                    this.currentPage = e.target.getAttribute("data-page");
                    setTimeout(() => {
                        const mainProductStickyHeight = document.querySelector(".main-product-sticky").offsetHeight || 0;
                        const reviewListTop = this.querySelector('[data-controls="controls"]').getBoundingClientRect().top + window.scrollY - mainProductStickyHeight;
                        window.scrollTo({ top: reviewListTop, behavior: "smooth" });
                    }, 300);
                    this.getReviews();
                });
                pagination.appendChild(pageButton);
            }
        }
    }

    setReviewSchema() {
        const schemaScript = document.querySelector('script[type="application/ld+json"][data-schema="main-product"]');
        const schema = JSON.parse(schemaScript.textContent);
        const reviewSchemaItems = this.reviews.map(review => ({
            "@type": "Review",
            "author": {
                "@type": "Person", 
                "name": review.author
            },
            "datePublished": review.created_date,
            "name": review.title || `Review by ${review.author}`,
            "reviewBody": review.body,
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": review.rating,
                "bestRating": 5,
                "worstRating": 1
            },
            ...(review.images.length > 0 && { "image": this.baseURL + review.images[0] })
        }));

        const reviewSchema = {
            "@context": "https://schema.org",
            "@type": "Product",
            "@id": schema["@id"],
            "reviews": reviewSchemaItems
        };

        const newSchemaScript = document.createElement("script");
        newSchemaScript.type = "application/ld+json";
        newSchemaScript.setAttribute("data-schema", "reviews");
        newSchemaScript.textContent = JSON.stringify(reviewSchema, null, 2);

        document.body.appendChild(newSchemaScript);
    }

    async getTagsForForm() {
        try {
            // Get tags for review form
            const fetchRes = await fetch(`${this.baseURL}/api/tags/?product_id=${this.productID}`, { cache: "no-cache" });
            const data = await fetchRes.json();
            this.tags = data.tags;
        } catch (e) {
            // TODO: hide tag part of review form
        }

        // for each review, create a new review item
        if (this.tags.length > 0) {
            function setFormTagValues(node, tagData, nameCount) {
                node.querySelector("label").textContent = tagData.value;
                node.querySelector("label").setAttribute("for", `input-ncol-reviews-tag-${tagData.ID}`);
                node.querySelector("input").setAttribute("id", `input-ncol-reviews-tag-${tagData.ID}`);
                node.querySelector("input").setAttribute("name", `tag-${nameCount}`);
                node.querySelector("input").setAttribute("value", tagData.ID);
            }

            // loop through the tag pairs
            let tagChoiceCount = 0;
            document.querySelector("#js-ncol-review-form-tagchoices-container").innerHTML = "";
            this.tags.forEach((tag) => {
                if (tag.left != null && tag.right != null) {
                    const tagChoiceNode = document.querySelector("#js-ncol-review-template-form-tagchoices").content.cloneNode(true);
                    const leftNode = tagChoiceNode.querySelector(".js-ncol-reviews-form-tagchoice-l");
                    const rightNode = tagChoiceNode.querySelector(".js-ncol-reviews-form-tagchoice-r");
                    setFormTagValues(leftNode, tag.left, tagChoiceCount);
                    setFormTagValues(rightNode, tag.right, tagChoiceCount);
                    document.querySelector("#js-ncol-review-form-tagchoices-container").appendChild(tagChoiceNode);
                    tagChoiceCount++;
                }
            });

            // loop through single tags
            let singleTagCount = 0;
            document.querySelector("#js-ncol-review-form-tagsmore-container").innerHTML = "";
            this.tags.forEach((tag) => {
                if (tag.left != null && tag.right == null) {
                    const tagFieldNode = document.querySelector("#js-ncol-review-template-form-tagfield").content.cloneNode(true);
                    setFormTagValues(tagFieldNode, tag.left, tag.left.ID);
                    document.querySelector("#js-ncol-review-form-tagsmore-container").appendChild(tagFieldNode);
                    singleTagCount++;
                }
            });
            if (singleTagCount == 0) {
                document.querySelector("#js-ncol-review-form-tagsmore-title").remove();
            }

            // if there were tags, show the section
            if (singleTagCount > 0 || tagChoiceCount > 0) {
                document.querySelector("#js-ncol-review-form-tags").classList.remove("hidden");
            }
        }
    }
}
customElements.define("ncol-reviews", NCOLReviews);
